/* wf-swatches – hover/klick på färgprick byter kortets bild till variantens bild (Wheelyshop 2026-09-14) */
(function () {
  if (window.wfSwatches) return;
  window.wfSwatches = 1;
  function imgOf(dot) {
    var c = dot.closest('a') || dot.closest('li');
    return c && c.querySelector('img');
  }
  function fade(im) {
    im.classList.add('wf-sw-swapping');
    var done = function () { im.classList.remove('wf-sw-swapping'); };
    im.addEventListener('load', done, { once: true });
    setTimeout(done, 900);
  }
  function put(im, src, srcset) {
    if ((im.getAttribute('src') || '') === src) return;
    fade(im);
    if (srcset) im.setAttribute('srcset', srcset); else im.removeAttribute('srcset');
    im.setAttribute('src', src);
    /* wf-center.js mäter motivet igen på den nya bilden */
    if (im.hasAttribute('data-wf-center')) { delete im.dataset.wfCentered; if (window.wfCenter) window.wfCenter.run(); }
  }
  function show(dot) {
    var im = imgOf(dot); if (!im || !dot.dataset.wfSwSrc) return;
    if (!('wfSwOrig' in im.dataset)) { im.dataset.wfSwOrig = im.getAttribute('src') || ''; im.dataset.wfSwOrigset = im.getAttribute('srcset') || ''; }
    put(im, dot.dataset.wfSwSrc, dot.dataset.wfSwSrcset || '');
  }
  function restore(group) {
    var picked = group.querySelector('.wf-sw__dot.is-picked');
    if (picked) { show(picked); return; }
    var first = group.querySelector('.wf-sw__dot'); var im = first && imgOf(first);
    if (im && 'wfSwOrig' in im.dataset && im.dataset.wfSwOrig) put(im, im.dataset.wfSwOrig, im.dataset.wfSwOrigset || '');
  }
  function select(dot) {
    var g = dot.parentNode;
    [].forEach.call(g.querySelectorAll('.wf-sw__dot'), function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on); d.classList.toggle('is-picked', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    show(dot);
    var a = dot.closest('a'); if (a && dot.dataset.wfSwHref) a.setAttribute('href', dot.dataset.wfSwHref);
  }
  var closest = function (t, s) { return t && t.closest ? t.closest(s) : null; };
  document.addEventListener('mouseover', function (e) { var d = closest(e.target, '.wf-sw__dot'); if (d) show(d); });
  document.addEventListener('mouseout', function (e) {
    var g = closest(e.target, '.wf-sw'); if (!g) return;
    if (e.relatedTarget && g.contains(e.relatedTarget)) return;
    restore(g);
  });
  document.addEventListener('click', function (e) {
    var d = closest(e.target, '.wf-sw__dot'); if (!d) return;
    e.preventDefault(); e.stopPropagation(); select(d);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var d = closest(e.target, '.wf-sw__dot'); if (!d) return;
    e.preventDefault(); e.stopPropagation(); select(d);
  }, true);
})();
